import React from 'react';
import { COLORS, FONTS } from '../../../styles/tokens';

// Fastpriskort: «Fastpris (mest du betaler)», stort redigerbart beløp og grønt prisforslag.
// label og unitSuffix overstyres for timepris («Timepris», «kr/time»); uten dem er kortet som før.
export default function FixedPriceCard({ value, onChange, hint, canRestore, onRestore, label = 'Fastpris (mest du betaler)', unitSuffix = null }) {
  return (
    <div style={styles.card}>
      <label htmlFor="new-order-fixed-price" style={styles.label}>{label}</label>
      <div style={styles.row}>
        <span style={styles.kr}>kr</span>
        <input
          id="new-order-fixed-price"
          type="number" inputMode="numeric" min={1} step={1}
          value={value}
          onChange={e => onChange(e.target.value)}
          placeholder="0"
          style={styles.input}
        />
        {unitSuffix && <span style={styles.suffix}>{unitSuffix}</span>}
      </div>
      {hint && <div style={styles.hint}>{hint}</div>}
      {canRestore && (
        <button type="button" onClick={onRestore} style={styles.restore}>Bruk prisforslag</button>
      )}
    </div>
  );
}

const styles = {
  card: { background: COLORS.white, borderRadius: 16, border: `1px solid ${COLORS.border}`, padding: '10px 14px' },
  label: { fontSize: 12, color: COLORS.textMid, display: 'block' },
  row: { display: 'flex', alignItems: 'baseline', gap: 8 },
  kr: { fontFamily: FONTS.display, fontWeight: 700, fontSize: 40, lineHeight: 1, color: COLORS.textDark },
  input: {
    flex: 1, minWidth: 0, border: 'none', outline: 'none', background: 'transparent', padding: 0,
    fontFamily: FONTS.display, fontWeight: 700, fontSize: 40, lineHeight: 1, color: COLORS.textDark,
  },
  suffix: { fontSize: 16, fontWeight: 600, color: COLORS.textMid },
  hint: { fontSize: 12, color: COLORS.success, fontWeight: 600, marginTop: 3 },
  restore: {
    marginTop: 6, padding: 0, border: 'none', background: 'none', cursor: 'pointer',
    fontSize: 13, fontWeight: 700, color: COLORS.textDark, textDecoration: 'underline',
  },
};
